import { Icon } from '@iconify/react';
import Modal from 'react-modal';
import { StyledButton } from '../../../../components/StyledButton';
import {
  ContentBody,
  ContentFooter,
  ContentHeader,
} from './styles';
import { IServicoPedidoAntecipacao } from '../../../../services/hooks/useEstabelecimento';

interface NoAnticipationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  servicoPedidoAntecipacao: IServicoPedidoAntecipacao | undefined;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',

    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',

    maxHeight: '500px',
    maxWidth: '600px',

    borderRadius: '12px',
  },
};

type AnticipationMessage = {
  [key: number]: string;
};

const bodyTextByCode: AnticipationMessage = {
  1: "",
  99: "Modalidade não disponível para esse CNPJ. Em caso de dúvidas, entre em contato com a Equipe de Backoffice através do Whatsapp (11)94785-6815.",
  98: "Volte em breve! Em caso de dúvidas, entre em contato com a Equipe de Backoffice através do Whatsapp (11)94785-6815.",
}

const titleTextByCode: AnticipationMessage = {
  1: "",
  99: "Antecipação indisponível",
  98: "Sistema em atualização",
}

export function NoAnticipationModal({
  isOpen,
  onRequestClose,
  servicoPedidoAntecipacao
}: NoAnticipationModalProps) {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        onRequestClose();
      }}
      contentLabel="Example Modal"
      style={customStyles}
    >
      <ContentHeader>
        <h2>{titleTextByCode?.[servicoPedidoAntecipacao?.status ?? 1] || "Antecipação indisponível"}</h2>
      </ContentHeader>
      <ContentBody>
        <p>
          {bodyTextByCode?.[servicoPedidoAntecipacao?.status ?? 1] || servicoPedidoAntecipacao?.descricao}
        </p>
        <ContentFooter>
          <StyledButton
            icon={<Icon icon="iconamoon:arrow-left-6-circle-fill" width={20} />}
            iconPosition="left"
            text="Voltar"
            color="#595044"
            onClick={onRequestClose}
          />
        </ContentFooter>
      </ContentBody>
    </Modal>
  );
}
